var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 760,
    width: 660,
    height: 48,
    fill: "#161310",
    opacity: 0.28
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 710,
    width: 580,
    height: 52,
    fill: "#31553f"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 762,
    width: 580,
    height: 28,
    fill: "#161310"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 682,
    width: 70,
    height: 28,
    fill: "#161310"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 682,
    width: 70,
    height: 28,
    fill: "#161310"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 210,
    width: 540,
    height: 430,
    fill: "#161310"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 230,
    width: 500,
    height: 390,
    fill: "#fffaef"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 250,
    width: 460,
    height: 350,
    fill: "#f2ead6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 250,
    width: 460,
    height: 42,
    fill: "#6f9b56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 266,
    width: 18,
    height: 18,
    fill: "#fffaef"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 266,
    width: 18,
    height: 18,
    fill: "#fffaef"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 266,
    width: 18,
    height: 18,
    fill: "#fffaef"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 330,
    width: 160,
    height: 22,
    fill: "#161310"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 374,
    width: 300,
    height: 18,
    fill: "#3a332a"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 412,
    width: 250,
    height: 18,
    fill: "#3a332a"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 450,
    width: 330,
    height: 18,
    fill: "#3a332a"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 510,
    width: 90,
    height: 42,
    fill: "#2e5dd6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 510,
    width: 90,
    height: 42,
    fill: "#d85b49"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 510,
    width: 90,
    height: 42,
    fill: "#31553f"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 552,
    width: 310,
    height: 14,
    fill: "#161310"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 535,
    y: 160,
    width: 180,
    height: 180,
    fill: "#161310"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 555,
    y: 180,
    width: 140,
    height: 140,
    fill: "#fffaef"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 575,
    y: 205,
    width: 100,
    height: 24,
    fill: "#31553f"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 575,
    y: 245,
    width: 24,
    height: 24,
    fill: "#161310"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 245,
    width: 24,
    height: 24,
    fill: "#161310"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 599,
    y: 286,
    width: 52,
    height: 14,
    fill: "#d85b49"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 555,
    y: 320,
    width: 140,
    height: 20,
    fill: "#161310"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 575,
    y: 350,
    width: 100,
    height: 150,
    fill: "#2e5dd6"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 535,
    y: 382,
    width: 40,
    height: 100,
    fill: "#2e5dd6"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 675,
    y: 382,
    width: 40,
    height: 100,
    fill: "#2e5dd6"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 462,
    width: 60,
    height: 28,
    fill: "#161310"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 675,
    y: 462,
    width: 60,
    height: 28,
    fill: "#161310"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 595,
    y: 500,
    width: 28,
    height: 110,
    fill: "#161310"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 627,
    y: 500,
    width: 28,
    height: 110,
    fill: "#161310"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 563,
    y: 610,
    width: 60,
    height: 28,
    fill: "#d85b49"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 627,
    y: 610,
    width: 60,
    height: 28,
    fill: "#d85b49"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 360,
    width: 95,
    height: 95,
    fill: "#161310"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 378,
    width: 59,
    height: 59,
    fill: "#fffaef"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 396,
    width: 23,
    height: 23,
    fill: "#2e5dd6"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 455,
    width: 95,
    height: 20,
    fill: "#161310"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 765,
    y: 390,
    width: 95,
    height: 95,
    fill: "#161310"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 783,
    y: 408,
    width: 59,
    height: 59,
    fill: "#fffaef"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 801,
    y: 426,
    width: 23,
    height: 23,
    fill: "#d85b49"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 765,
    y: 485,
    width: 95,
    height: 20,
    fill: "#161310"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 150,
    width: 24,
    height: 24,
    fill: "#161310"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 174,
    width: 24,
    height: 24,
    fill: "#161310"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 174,
    width: 24,
    height: 24,
    fill: "#161310"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 198,
    width: 24,
    height: 24,
    fill: "#161310"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 174,
    width: 24,
    height: 24,
    fill: "#fffaef"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 820,
    y: 180,
    width: 24,
    height: 24,
    fill: "#161310"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 844,
    y: 204,
    width: 24,
    height: 24,
    fill: "#161310"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 796,
    y: 204,
    width: 24,
    height: 24,
    fill: "#161310"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 820,
    y: 228,
    width: 24,
    height: 24,
    fill: "#161310"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 820,
    y: 204,
    width: 24,
    height: 24,
    fill: "#fffaef"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.e7a7a2527423691ffe61775450778c94.svg";
export { ForwardRef as ReactComponent };